import React ,{useContext} from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import NavigateButton from "../../../../components/buttonsNavigate";
import { CiInboxOut, CiInboxIn } from "react-icons/ci";
import hocStarredPage from "../../../../components/hocStarredPage";

const Palletv2 = () => {
  const history = useNavigate();
  const permissions = JSON.parse(localStorage.getItem("permissions"));

  return (
    <>
      <div className=" h-full bg-white">
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          {/* header */}

          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">Pallet</h2>
            </div>
          </div>
        </div>

        <div className="  grid grid-cols-2 container gap-x-6 gap-y-4">
        { (window.location.host.startsWith("localhost") || window.location.host === "pda.ishtari.com") && (
          <>
           { permissions.pda_others_pallet_assign &&(
          <NavigateButton
            name={"ASSIGN"}
            color={"bg-dbase"}
            icon={<CiInboxIn className=" text-3xl" />}
            onclick={() => history("assign")}
          />
        )}
         { permissions.pda_others_pallet_unassign &&(
          <NavigateButton
            name={"UNASSIGN"}
            icon={<CiInboxOut className=" text-3xl" />}
            color={"bg-[rgb(96,165,250)]"}
            onclick={() => history("unassign")}
          />
         )}
          </>
        )}
          { (window.location.host === "pda.ishtari.com.gh" || window.location.host === "pda.energyplus-lb.com") && (
            <>
            
            <NavigateButton
              name={"ASSIGN"}
              color={"bg-dbase"}
              icon={<CiInboxIn className=" text-3xl" />}
              onclick={() => history("assign")}
            />
         
            <NavigateButton
              name={"UNASSIGN"}
              icon={<CiInboxOut className=" text-3xl" />}
              color={"bg-[rgb(96,165,250)]"}
              onclick={() => history("unassign")}
            />
            </>
          )}
       
        </div>
      </div>
    </>
  );
};

export default hocStarredPage(Palletv2);
